export default __webpack_public_path__ + "static/media/ishopify-admin-dashboard.2e1f8bf5.PNG";